 /** @format */

import { Box, Container } from '@mui/material';
import { createContext, useState } from 'react';

import KPIContainer, { TABS_MAPPING } from './KPI/KPIContainer';
import PerformanceStrip from './Performance/PerformanceStrip';
import Performance from './Performance/Performance';
import GuageContainer from './GuageContainer';
import BarLine from './BARLine/BarLine';
import BookingPace from './BookingPace/BookingPace';
import RevBudget from './RevBudget/RevBudget';
import InfoHeader from './InfoHeader';
import PrintCaution from '../BizBarometr/components/footer/PrintCaution';

import {
  COMPONENT_TITLE_SX,
  COMPONENT_SUBTITLE_SX,
} from './homeStyles';

import './homeDataFont.css';

export const HomeContext = createContext();

export { COMPONENT_TITLE_SX, COMPONENT_SUBTITLE_SX } from './homeStyles';

function Home() {
  const [activeTab, setActiveTab] = useState('TODAY');
  const [kpiData, setKpiData] = useState({});

  const handleActiveTabChange = (newTab) => {
    setKpiData({});
    setActiveTab(newTab);
  };

  return (
    <HomeContext.Provider
      value={{
        activeTab,
        setActiveTab: handleActiveTabChange,
        kpiData,
        setKpiData,
      }}
    >
      <Container
        className="home-page"
        maxWidth="xl"
        sx={{
          mt: {
            xs: 0,
            sm: 2,
          },
          px: {
            xs: 0,
            sm: 2,
            md: 3,
          },
        }}
      >
        <InfoHeader />

        <KPIContainer />

        <GuageContainer />

        <ActiveTab activeTab={activeTab} />

        <PerformanceStrip />

        <Performance />

        <RevBudget />

        <Container
          maxWidth="lg"
          sx={{
            width: '100%',
            px: {
              xs: 0,
              sm: 2,
              md: 3,
            },
          }}
        >
          <BookingPace />

          <BarLine />

          <Box
            className="flash-print-caution"
            sx={{
              display: 'none',
              '@media print': {
                display: 'block',
                width: '100%',
                marginTop: '12px',
                boxSizing: 'border-box',
                breakInside: 'avoid',
                pageBreakInside: 'avoid',
              },
            }}
          >
            <PrintCaution />
          </Box>
        </Container>
      </Container>
    </HomeContext.Provider>
  );
}

const style = {
  width: '15px',
  height: '15px',
  borderRadius: '50%',
  backgroundColor: 'primary.main',
};

function ActiveTab({ activeTab }) {
  const dots = Object.keys(TABS_MAPPING).map((key) => (
    <Box
      key={key}
      sx={{
        ...style,
        backgroundColor:
          key === activeTab ? 'primary.main' : 'grey.400',
      }}
    />
  ));

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
        pt: 1,
        justifyContent: 'center',
      }}
    >
      {dots}
    </Box>
  );
}

export default Home;
